import { render } from "./ForgetPwdView.vue?vue&type=template&id=b1c71650&scoped=true"
import script from "./ForgetPwdView.vue?vue&type=script&lang=js"
export * from "./ForgetPwdView.vue?vue&type=script&lang=js"

import "./ForgetPwdView.vue?vue&type=style&index=0&id=b1c71650&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1c71650"]])

export default __exports__